export const PageDataState = {
    Searchs: {
        target_industries_id: {
            type: 'text',
            id: 'target_industries_id',
            label: 'อุตสาหกรรมเป้าหมาย',
            value: '',
            placeholder: 'อุตสาหกรรมเป้าหมาย',
        },
        faculty_id: {
            type: 'text',
            id: 'faculty_id',
            label: 'คณะ',
            value: '',
            placeholder: 'คณะ',
        },
        academy_name: {
            type: 'text',
            id: 'academy_name',
            label: 'ชื่อสถานศึกษา',
            value: '',
            placeholder: 'ชื่อ',
        },
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false,
            },
            error: { status: null, msg: ''}
        },
        academy_id: {
            type: 'select',
            id: 'academy_id',
            label: 'สถานศึกษา',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: ''}
        },
        faculty_id: {
            type: 'select',
            id: 'faculty_id',
            label: 'คณะ',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: ''}
        },
        department_id: {
            type: 'select',
            id: 'department_id',
            label: 'สาขาวิชา',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: ''}
        },
        education_level_id: {
            type: 'select',
            id: 'education_level_id',
            label: 'ระดับการศึกษา',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: ''}
        },
        target_industries_id: {
            type: 'select',
            id: 'target_industries_id',
            label: 'อุตสาหกรรมเป้าหมาย',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: ''}
        },
        academic_year: {
            type: 'select',
            id: 'academic_year',
            label: 'ปีการศึกษา',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: ''}
        },
        student_count: {
            type: 'text',
            id: 'student_count',
            label: 'จำนวนนักศึกษา',
            value: '',
            validator: {
                type: 'number',
                required: true,
            },
            error: { status: null, msg: ''}
        },
    },
    InputGroup: {}
}